<template>
  <div v-if="contract.id" class="form-detail">
    <h1 class="form-row justify-content-between">
      <span>Thông tin hợp đồng</span>
      <router-link
        class="d-flex align-items-center f12"
        v-if="contract.formContract === 'E_CONTRACT' && !hideReview"
        :to="`/contract-review/${encodeURIComponent(contract.id)}`"
      >
        Xem
      </router-link>
    </h1>
    <Content title="Mã hợp đồng" :content="contract.code"></Content>
    <Content title="Cách ký">
      {{ contract.isRemote && contract.isRemote === true ? 'Ký từ xa' : '' }}
    </Content>
    <Content title="Loại hợp đồng">
      {{ contract.typeCustomer | fomatCustomtype }}
    </Content>
    <Content title="Nhóm dịch vụ" :content="contract.groupService"></Content>
    <Content title="Dịch vụ">
      {{ contract.serviceTypes.join(', ') }}
    </Content>
    <Content title="Đã chuyển đổi HĐ Ngân Lượng?">
      {{ contract.isTransferNganluong ? 'Đã chuyển đổi' : 'Chưa chuyển đổi' }}
    </Content>
    <Content v-if="contract.service === 'COMBOSELL'" title="Gói">
      {{ comboTitle }}
    </Content>
    <Content title="Ngày tạo">
      {{ contract.dateCreated || contract.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
    </Content>
    <Content v-if="contract.dateSign" title="Ngày ký">
      {{ contract.dateSign | formatDate('HH:mm DD/MM/YYYY') }}
    </Content>
    <Content v-if="contract.activeDate" title="Ngày kích hoạt">
      {{ contract.activeDate | formatDate('HH:mm DD/MM/YYYY') }}
    </Content>
    <Content v-if="contract.dateCancel || contract.dateReject" title="Ngày huỷ">
      {{ contract.dateCancel || contract.dateReject | formatDate('HH:mm DD/MM/YYYY') }}
    </Content>
    <Content v-if="contract.depositType" title="Hình thức">
      {{ contract.depositType | mapdepositType }}
    </Content>
    <Content v-if="contract.depositType" title="Trạng thái Mpos">
      {{ contract.mposState | transformData(Config.mposState) }}
    </Content>
    <Content v-if="contract?.reserveStatus" title="Trạng thái bảo lưu">
      {{ contract?.reserveStatus | transformData(Config.reserveStatusOptions) }}
    </Content>
    <Content v-if="contract?.reserveTime" title="Thời gian bảo lưu">
      {{ contract.reserveTime | formatDate('HH:mm DD/MM/YYYY') }}
    </Content>
    <Content v-if="contract?.reserveNote" title="Ghi chú bảo lưu">
      {{ contract?.reserveNote }}
    </Content>
    <Content v-if="contract.depositType" title="Ghi chú Mpos">
      {{ contract.mposNote }}
    </Content>
    <Content title="Mô tả" :content="contract.description"></Content>
    <Content title="Trạng thái">
      <span class="f12 badge" :class="contract.state">
        {{ contract.state | mapTextStatus(Config.listStatusContract) }}
      </span>
    </Content>
    <Content title="Trạng thái GS">
      <span
        class="ml-2 f12 badge"
        v-if="contract.stateCollaborator"
        :class="contract.stateCollaborator"
      >
        {{ contract.stateCollaborator | mapTextStatus(listStateCollaborator) }}
      </span>
    </Content>
    <Content title="Trạng thái Megabiz">
      <span class="f12 badge" v-if="contract.megabizStt" :class="contract.megabizStt">
        {{ contract.megabizStt | mapTextStatus(listStatusMegabiz) }}
      </span>
    </Content>
    <Content title="Lý do" :content="reasonContrract"></Content>
    <Content title="Khách hàng doanh nghiệp của Tingbox" v-if="contract?.tingboxCompanyMc">
      <input
        type="checkbox"
        disabled
        :checked="contract?.tingboxCompanyMc"
        class="mr-2"
        style="width: 18px; height: 18px"
      />
    </Content>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import Content from './Content.vue'
  import last from 'lodash/last'
  import { ComboService } from '@/services/combo.service'
  import { showMess } from '@/config/utils'
  export default {
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      listStatusMegabiz: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
      hideReview: {
        type: Boolean,
        default: false,
      },
    },
    components: { Content },
    data() {
      return {
        Config,
        listStateCollaborator: [
          { id: 'APPROVED', text: 'GS đã duyệt' },
          { id: 'WAITING', text: 'Chờ GS duyệt' },
          { id: 'REJECTED', text: 'GS từ chối' },
        ],
        optionCombo: [],
      }
    },
    computed: {
      agentInfo() {
        return this.contract.agentInfo ?? {}
      },
      reasonContrract() {
        if (
          !['REJECTED_SA', 'REJECTED_MA', 'ADDITIONAL', 'EXPERTISE_COLLABORATOR'].includes(
            this.contract.state
          )
        )
          return null
        if (this.contract.reasonRejected) return last(this.contract.reasonRejected)
        else if (this.contract.reasonRejectedBYMPOS) return last(this.contract.reasonRejected)
        else if (this.contract.reasonCollaborator) return this.contract.reasonCollaborator
        return null
      },
      mapTitleCombo() {
        return this.optionCombo.reduce((acc, e) => {
          acc[e.id] = e.text
          return acc
        }, {})
      },
      comboTitle() {
        const code = this.contract?.appendixPackages?.[0]?.appendixPackage?.code
        return code ? this.mapTitleCombo[code] : ''
      },
    },
    async created() {
      await this.getPlanConfig()
    },
    methods: {
      async getPlanConfig() {
        try {
          const res = await ComboService.getPlaneServiceCommbo({
            page: 1,
            size: 1000,
          })
          if (res.code === 1000) {
            const groupService = res.data?.groupService?.find(e => e.group === 'SELL')
            const comboService = groupService?.service?.find(e => e.code === 'COMBOSELL')
            const newData = comboService?.plan || []

            this.optionCombo =
              newData?.map(e => {
                return {
                  id: e.code,
                  text: e.title,
                }
              }) || []
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        }
      },
    },
  }
</script>

<style scoped></style>
